// extracted by mini-css-extract-plugin
export default {"wrapper":"BackSectionLayout_wrapper__gDyaP","backSection":"BackSectionLayout_backSection__HghAn"};